export const DONATION_GOAL = 'DONATION_GOAL';
export const NOTIFICATION = 'NOTIFICATION';
export const MESSAGE = 'MESSAGE';
export const TOP_DONORS = 'TOP_DONORS';

export const NAVIGATION_LIST = [
  {
    href: 'streamer.widgets.goal',
    label: 'common.fundraising',
    icon: 'fundraising',
    help: 'https://help.capusta.space/widget',
  },
  {
    href: 'streamer.widgets.notification',
    label: 'common.alerts',
    icon: 'plus-inside-bell',
    help: 'https://help.capusta.space/widget_notification',
  },
  {
    href: 'streamer.widgets.message',
    label: 'common.messages',
    icon: 'message',
    help: 'https://help.capusta.space/widget_message',
  },
  {
    href: 'streamer.widgets.donors',
    label: 'top.donators',
    icon: 'star',
    help: 'https://help.capusta.space/widget_top',
  },
];

export const SENDER_FIELDS_BY_WIDGET = {
  [NOTIFICATION]: [
    {
      name: 'name',
      value: 'sender.name',
    },
  ],
  [MESSAGE]: [
    {
      name: 'name',
      value: 'sender.name',
    },
    {
      name: 'message',
      value: 'sender.message',
    },
  ],
  [TOP_DONORS]: [
    {
      name: 'name',
      value: 'sender.name',
    },
  ],
};

export const STREAMER_HOSTNAME_LIST = ['youtube.com', 'twitch.tv'];
